import { useParams } from 'react-router-dom';
import { GuestSessionBoundary } from './GuestSessionBoundary';
import { GuestShell } from './GuestShell';
import { OrderDetailPageV2 } from '../orders/v2/OrderDetailPageV2';

/**
 * The order a guest's acceptance produced, in the same nav-less shell as the
 * quote. Accepting turns the quote into an order, and the guest still has to
 * pay for it — so the flow can't stop at the quote.
 *
 * The SAME page a signed-in client gets at /orders/:id. It was left on v1 when
 * v2 became the default route, which quietly made guests the only people still
 * reading the old page — and the one audience least able to ask why their order
 * looks different from the link they were sent.
 */
export function GuestOrderPage() {
	const { id } = useParams<{ id: string }>();

	return (
		<GuestSessionBoundary>
			<GuestShell>
				<OrderDetailPageV2 guest key={id} />
			</GuestShell>
		</GuestSessionBoundary>
	);
}
